<template>
    <div id="app">
        <loading name='load menu'>
            <router-view name="nav"/>
            <router-view/>
            <router-view name="footer" v-if="!$wait.any"/>
        </loading>
    </div>
</template>

<script>
  export default {
    name: 'Web'
  };
</script>
